import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M14.525 4.32a5.334 5.334 0 0 1-3.592 9.01l-.266.006-4.391-.001 1.531 1.531c.231.232.257.591.077.85l-.077.093a.67.67 0 0 1-.85.077l-.093-.077-2.669-2.669a.67.67 0 0 1-.077-.85l.077-.092 2.67-2.67a.667.667 0 0 1 1.02.851l-.078.092-1.531 1.53 4.39.001a4 4 0 0 0 3.994-3.765l.007-.235c0-1.096-.441-2.089-1.155-2.811a.667.667 0 0 1 .918-.967zM9.045.118l.093.077 2.669 2.67.077.092a.67.67 0 0 1 0 .758l-.077.092-2.669 2.669-.092.077a.67.67 0 0 1-.758 0l-.093-.077-.077-.092a.67.67 0 0 1 0-.759l.077-.092 1.53-1.532-4.392.001A4 4 0 0 0 1.34 7.767l-.007.235c0 1.093.439 2.083 1.149 2.805a.667.667 0 0 1-.952.931 5.334 5.334 0 0 1 3.537-9.063l.266-.006 4.392-.001-1.53-1.53-.077-.092a.667.667 0 0 1 .928-.928"
    />
  </svg>
);
export default SvgRepeatIcon;
